
import EoLogoAnbi from './EoLogoAnbi.vue'
import EoLogoBeam from './EoLogoBeam.vue'
import EoLogoBijbelopen from './EoLogoBijbelopen.vue'
import EoLogoBlauwBloed from './EoLogoBlauwBloed.vue'
import EoLogoCorporate from './EoLogoCorporate.vue'
import EoLogoDitIsDeDag from './EoLogoDitIsDeDag.vue'
import EoLogoEo from './EoLogoEo.vue'
import EoLogoEoMetterdaad from './EoLogoEoMetterdaad.vue'
import EoLogoEoMetterdaadJubileum from './EoLogoEoMetterdaadJubileum.vue'
import EoLogoEva from './EoLogoEva.vue'
import EoLogoIkMisJe from './EoLogoIkMisJe.vue'
import EoLogoLazarus from './EoLogoLazarus.vue'
import EoLogoNederlandZingt from './EoLogoNederlandZingt.vue'
import EoLogoVisie from './EoLogoVisie.vue'

export const BRANDS = Object.freeze({
  ANBI: 'anbi',
  BEAM: 'beam',
  BIJBELOPEN: 'bijbelopen',
  BLAUWBLOED: 'blauw-bloed',
  CORPORATE: 'corporate',
  DITISDEDAG: 'dit-is-de-dag',
  EO: 'eo',
  EOMETTERDAAD: 'eo-metterdaad',
  EOMETTERDAADJUBILEUM: 'eo-metterdaad-jubileum',
  EVA: 'eva',
  IKMISJE: 'ik-mis-je',
  LAZARUS: 'lazarus',
  NEDERLANDZINGT: 'nederland-zingt',
  VISIE: 'visie',
})

export const LOGO_SIZES = Object.freeze({
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  XXL: 'xxl',
})

export default {
  name: 'EoLogo',
  components: {
    EoLogoAnbi,
    EoLogoBeam,
    EoLogoBijbelopen,
    EoLogoBlauwBloed,
    EoLogoCorporate,
    EoLogoDitIsDeDag,
    EoLogoEo,
    EoLogoEoMetterdaad,
    EoLogoEoMetterdaadJubileum,
    EoLogoEva,
    EoLogoIkMisJe,
    EoLogoLazarus,
    EoLogoNederlandZingt,
    EoLogoVisie,
  },
  props: {
    /**
     * Show the logo of a brand, brand or platform
     */
    brand: {
      type: String,
      validator: prop => Object.values(BRANDS).includes(prop),
      default: 'eo',
    },
    /**
     * Size of the icon: (xs) (sm) (md) (lg) (xl) (xxl)
     */
    size: {
      type: String,
      validator: prop => Object.values(LOGO_SIZES).includes(prop),
      default: 'sm',
    },
    /**
     * Style: color
     */
    color: {
      type: String,
      default: null,
    },
    /**
     * Style: make the logo inline with text
     */
    inline: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes () {
      return {
        'eo-logo': true,
        [this.brand]: !!this.brand,
        ['is-' + this.size]: true,
        'is-inline': this.inline,
      }
    },
    logoComponent () {
      return `eo-logo-${this.brand}`
    },
  },
  render: function (createElement) {
    return createElement(
      this.logoComponent,
      {
        class: this.classes,
        props: {
          size: this.size,
          color: this.$color.getHex(this.color) || 'currentColor',
        },
      },
    )
  },
}
